module.exports={
        "0":{
                reason:"Instantiation error. Please refresh and try again.",
                code:0 
            },
        "1":{
                reason:"content invalid",
                code:1
            }, 
        "2":{
                reason:"Unauthorized Access",
                code:2
            },
        "3":{
                reason:"Content not bought",
                code:3
            },
        "4":{
                reason:"Manifest Loading Error",
                code:4
            },
        "5":{
                reason:"Session Loading Error",
                code:5
            },
        "6":{
                reason:'Streaming Error',
                code:6
            }
    }
